const members = [
    {
        "id": 2,
        "nome": "Ezequiel Sousa",
        "funcao": "Desenvolvedor Back-End",
        "habilidades_tecnicas": "Java, Spring Boot, MySQL, REST APIs",
        "foto_url": "https://avatars.githubusercontent.com/u/63311919?s=400&u=301318136dda6045f6732b40d8c157ad37ca1d42&v=4",
        "redes_sociais": [
            {
                "url": "https://linkedin.com/in/escowolf",
                "fa": "fa-linkedin"
            },
            {
                "url": "https://github.com/Escowolf",
                "fa": "fa-github"
            },
            {
                "url": "https://twitter.com/escwolf",
                "fa": "fa-instagram"
            }
        ]
    },
    /*
    {
        "id": 1,
        "nome": "Beatriz Bottai",
        "funcao": "Designer UX/UI",
        "habilidades_tecnicas": "Adobe XD, Figma, Photoshop, Design Thinking",
        "foto_url": "https://avatars.githubusercontent.com/u/90660719?v=4",
        "redes_sociais": [
            {
                "url": "https://www.linkedin.com/in/beatrizbottai/",
                "fa": "fa-linkedin"
            },
            {
                "url": "https://github.com/BeatrizBottai",
                "fa": "fa-github"
            }
        ]
    },
    {
        "id": 3,
        "nome": "Jonathas Ricardo",
        "funcao": "Desenvolvedor Front-End",
        "habilidades_tecnicas": "HTML, CSS, JavaScript, React",
        "foto_url": "https://avatars.githubusercontent.com/u/71514703?v=4",
        "redes_sociais": [
            {
                "url": "https://www.linkedin.com/in/jonathas-ricardo/",
                "fa": "fa-linkedin"
            },
            {
                "url": "https://github.com/JohnRSS",
                "fa": "fa-github"
            }
        ]
    }
    */
];

export default members;
